import { IAppState } from '../../redux';
import { selectActiveAdditionalIds } from '../publishTerms';

const replaceHighlightWithColor = (str: string) => str.replace('highlight', 'color');

export const selectAnalyticsVariant = (state: IAppState): string | undefined => {
  const { selectedServiceId } = state.publishTerms;

  if (!selectedServiceId) {
    return undefined;
  }

  const additionals = selectActiveAdditionalIds(state);

  const serviceIds = [...selectedServiceId.split('+'), ...additionals];

  return serviceIds.map(replaceHighlightWithColor).join('/');
};
